module.exports = __webpack_public_path__ + "static/mobile-app-development-96fa9b8e558d4a0d4569f2c32f5f661a.jpg";